import React from 'react';
import propTypes from 'prop-types';

export const DraftIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ic_fluent_drafts_24_filled</title>
      <desc>Created with Sketch.</desc>
      <g
        id="🔍-Product-Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="ic_fluent_drafts_24_filled" fill={color} fillRule="nonzero">
          <path
            d="M13.9391717,4.99957288 L19.0001717,10.0605729 L9.06200371,19.9986565 C8.78512854,20.2755316 8.44079112,20.4753584 8.06302761,20.5783848 L2.94733805,21.9735729 C2.38746387,22.1262658 1.87373417,21.6125361 2.02642713,21.0526619 L3.4216152,15.9369724 C3.52464161,15.5592089 3.72446837,15.2148715 4.00134354,14.9379963 L13.9391717,4.99957288 Z M6.525,10.9995729 L5.025,12.4995729 L2.75,12.5 C2.33578644,12.5 2,12.1642136 2,11.75 C2,11.3357864 2.33578644,11 2.75,11 L6.525,10.9995729 Z M20.8773586,2.8252892 L21.0303301,2.96966991 L21.1747108,3.12264143 C22.4260103,4.52786334 22.3778834,6.68277675 21.0303301,8.03033009 L20.0601717,8.99957288 L14.9991717,3.93957288 L15.9696699,2.96966991 C17.3172232,1.62211658 19.4721367,1.57398967 20.8773586,2.8252892 Z M10.525,6.99957288 L9.025,8.49957288 L2.75,8.5 C2.33578644,8.5 2,8.16421356 2,7.75 C2,7.33578644 2.33578644,7 2.75,7 L10.525,6.99957288 Z M14.525,2.99957288 L13.025,4.49957288 L2.75,4.5 C2.33578644,4.5 2,4.16421356 2,3.75 C2,3.33578644 2.33578644,3 2.75,3 L14.525,2.99957288 Z"
            id="🎨-Color"
          ></path>
        </g>
      </g>
    </svg>
  );
};
DraftIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
DraftIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
